/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable max-len */
import { AboutHero } from '../blocks/AboutHero';
import SweepstakesGallery from '../blocks/SweepstakesGallery';

export const SweepstakePage = () => {
  return (
    <>
      <SweepstakesGallery
        // useSweepstakeBackground
        stackedContent={[
          {
            heroTitle: 'Our <strong>sweepstakes</strong>',
            className: 'text-xumoDarkPlum',
          },
          {
            bodyBase: '',
            className: 'type-body max-w-[350px] md:max-w-[500px] mx-auto lg:mx-0 lg:max-w-[800px]',
          },
        ]}
        sweepstakes={[
          {
            id: 'xumo-nascar-2026-1',
            tabTitle: 'NASCAR® Daytona',
            headingBold: 'Enter for a chance to win two tickets to NASCAR® in Daytona',
            startDate: '2026-08-12T04:00:00Z',
            endDate: '2026-08-18T03:59:59Z',
            rulesLink: 'http://therulespage.com/XumoNASCAR',
            hideWhenSweepstakeEnded: false,
            successMessage: 'You’re now entered for a chance to win two NASCAR® tickets!',
          },
          {
            id: 'xumo-nascar-2026-2',
            tabTitle: 'NASCAR® Bristol',
            headingBold: 'Enter for a chance to win two tickets to NASCAR® in Bristol',
            startDate: '2026-08-18T04:00:00Z',
            endDate: '2026-08-27T03:59:59Z',
            rulesLink: 'http://therulespage.com/XumoNASCAR',
            hideWhenSweepstakeEnded: true,
          },
          {
            id: 'xumo-nascar-2026-3',
            tabTitle: 'NASCAR® Las Vegas',
            headingBold: 'Enter for a chance to win two tickets to NASCAR® in Las Vegas',
            startDate: '2026-08-12T04:00:00Z',
            endDate: '2026-08-18T03:59:59Z',
            rulesLink: 'http://therulespage.com/XumoNASCAR',
            hideWhenSweepstakeEnded: false,
            successMessage: 'You’re now entered for a chance to win two NASCAR® tickets!',
          },
        ]}
      />
    </>
  );
};
